import * as Yup from 'yup';

export const validationSchema = Yup.object({
  firstName: Yup.string().nullable(true).required('Povinná položka'),
  lastName: Yup.string().nullable(true).required('Povinná položka'),
  sex: Yup.string().nullable(true).required('Povinná položka'),
  email: Yup.string().nullable(true).email('Neplatná emailová adresa').required('Povinná položka'),
  birthDate: Yup.date().nullable(true).required('Povinná položka'),
  citizenshipCountryId: Yup.string().nullable(true).required('Povinná položka'),
  permanentResidence: Yup.object({
    municipality: Yup.string().nullable(true).required('Povinná položka'),
    street: Yup.string().nullable(true).required('Povinná položka'),
    zip: Yup.string().nullable(true).required('Povinná položka'),
  }).required('Povinná položka'),

  researchSheetDto: Yup.object({
    proofOfIdentityType: Yup.string().nullable(true).required('Povinná položka'),
    proofOfIdentityValue: Yup.string().nullable(true).required('Povinná položka'),
    researchTopic: Yup.string().nullable(true).required('Povinná položka'),
    researchCategories: Yup.array().required('Povinná položka'),
    type: Yup.string().nullable(true).required('Povinná položka'),
    legalEntityName: Yup.mixed().test('Název právnické osoby', '', validateLegalEntityName),
    legalEntityOffice: Yup.object({
      municipality: Yup.mixed().test('Adresa právnické osoby - Obec', '', validateLegalEntityOffice),
      street: Yup.mixed().test('Adresa právnické osoby - Ulice', '', validateLegalEntityOffice),
      zip: Yup.mixed().test('Adresa právnické osoby - PSČ', '', validateLegalEntityOffice),
    }),
  }),

  confirmation: Yup.boolean().nullable(true).required('Musíte udělit souhlas').oneOf([true], 'Musíte udělit souhlas'),
  confirmation2: Yup.boolean().nullable(true).required('Musíte udělit souhlas').oneOf([true], 'Musíte udělit souhlas'),
});

function validateLegalEntityName(value) {
  const lastIndex = (this?.from?.length ?? 1) - 1;
  const values = this?.from?.[lastIndex]?.value ?? {};
  const { createError, path } = this;

  const isCredential = values?.researchSheetDto?.type === 'CREDENTIAL';

  if (isCredential && !value) {
    return createError({
      path,
      message: `Povinná položka`,
    });
  }
}

function validateLegalEntityOffice(value) {
  const lastIndex = (this?.from?.length ?? 1) - 1;
  const values = this?.from?.[lastIndex]?.value ?? {};
  const { createError, path } = this;

  const isCredential = values?.researchSheetDto?.type === 'CREDENTIAL';

  if (isCredential && !value) {
    return createError({
      path,
      message: `Povinná položka`,
    });
  }
}
